export default function translate(i18n, propriete) {
  let libellePropriete = propriete;
  if (propriete.indexOf('lignesCommande') === 0) {
    libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
    if (libellePropriete === 'Libelle') return i18n.t('validationDevis.name.libelleLigneCommande');
    if (libellePropriete === 'Quantite') return i18n.t('validationDevis.name.quantiteLigneCommande');
    if (libellePropriete === 'PrixUnitaire') return i18n.t('validationDevis.name.prixUnitaireLigneCommande');
    if (libellePropriete === 'Remise') return i18n.t('validationDevis.name.remiseLigneCommande');
    if (libellePropriete === 'TauxTva') return i18n.t('validationDevis.name.tauxTvaLigneCommande');
    if (libellePropriete === 'NumStand') return i18n.t('validationDevis.name.numStand');
    if (libellePropriete.indexOf('LignesCommande') === 0) {
      libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
      if (libellePropriete === 'Quantite') return i18n.t('validationDevis.name.quantiteLigneCommande');
      if (libellePropriete === 'PrixUnitaire') return i18n.t('validationDevis.name.prixUnitaireLigneCommande');
      if (libellePropriete === 'Remise') return i18n.t('validationDevis.name.remiseLigneCommande');
    }
    if (libellePropriete.indexOf('LignesRemise') === 0) {
      libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
      if (libellePropriete === 'Remise') return i18n.t('validationDevis.name.remise');
    }
    if (libellePropriete.indexOf('LigneCommandeDispositif') === 0) {
      libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
      if (libellePropriete === 'NomDispositif') {
        return i18n.t('validationDevis.name.nomDispositif');
      }
      if (libellePropriete === 'MaterielTypeId') {
        return i18n.t('validationDevis.name.materielTypeId');
      }
      if (libellePropriete === 'DispositifTypeId') {
        return i18n.t('validationDevis.name.dispositifTypeId');
      }
      if (libellePropriete === 'MaterielFormatId') {
        return i18n.t('validationDevis.name.materielFormatId');
      }
    }
    return libellePropriete;
  }

  if (propriete.indexOf('intervenant') === 0) {
    libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
    if (libellePropriete === 'Repartition') return i18n.t('validationDevis.name.repartitionIntervenant');
  }
  if (propriete === 'dateDevisCommande') return i18n.t('validationDevis.name.dateDevisCommande');
  if (propriete === 'dateValidite') return i18n.t('validationDevis.name.dateValidite');
  if (propriete === 'tauxEscompte') return i18n.t('validationDevis.name.tauxEscompte');
  if (propriete === 'tauxPenalite') return i18n.t('validationDevis.name.tauxPenalite');
  if (propriete === 'role') return i18n.t('validationDevis.name.role');

  if (propriete.indexOf('echeanciers') !== -1) {
    libellePropriete = libellePropriete.slice(libellePropriete.lastIndexOf('.') + 1);
    if (libellePropriete === 'dateDebut') {
      return 'echeancierFacturation.messages.errors.required.dateDebutEcheance';
    }
    if (libellePropriete === 'dateFin') {
      return 'echeancierFacturation.messages.errors.required.dateFinEcheance';
    }
    if (libellePropriete === 'datePrevisionnelleFacturation') {
      return 'echeancierFacturation.messages.errors.required.dateFinPremiereEcheance';
    }
    if (libellePropriete === 'tiersId') {
      return 'echeancierFacturation.messages.errors.required.payeur';
    }
    if (libellePropriete === 'montant') {
      return 'echeancierFacturation.messages.errors.required.montant';
    }
    if (libellePropriete === 'CommentaireFacturation') {
      return i18n.t('echeancierFacturation.messages.errors.required.commentaireFacturation');
    }
  }

  if (propriete.indexOf('etatSuivis') === 0) {
    libellePropriete = libellePropriete.slice(libellePropriete.lastIndexOf('.') + 1);
    if (libellePropriete === 'etatSuiviId') return i18n.t('validationCommande.name.etatSuiviId');
  }
  return propriete;
}
